// React libraries
import React, { useEffect, useState } from "react";
// Custom Styles
import { useStyles } from "./WarehouseModusPageStyles";
// Material-UI Core
import { Grid } from "@mui/material";
import BlueGradientHeader from "../BlueGradientHeader";
import PageWrapper from "../PageWrapper";
import GreyButton from "../GreyButton";
import ScanContentBar from "../ScanContentBar";
export const WarehouseModusPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data, totalWarehouse, warehouseLayout, scanContentBarText } = props;
    const [warehouseList, setWarehouseList] = useState(data);
    const [totalQuantity, setTotalQuantity] = useState(0);
    useEffect(() => {
        setWarehouseList(data);
    }, [data]);
    useEffect(() => {
        setTotalQuantity(warehouseList.length);
    }, [warehouseList]);
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, "Inventory Counting"),
                    React.createElement("sub", null,
                        "Inventory List ",
                        React.createElement("b", null, "40")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 40 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(ScanContentBar, { text: scanContentBarText || WarehouseModusPage.defaultProps.scanContentBarText })),
                    totalWarehouse ? totalWarehouse > 0 &&
                        React.createElement(Grid, { container: true, className: classes.progressBar },
                            React.createElement(Grid, { item: true, md: 12 }, totalQuantity + " from " + totalWarehouse + " completed"))
                        : null,
                    React.createElement(Grid, { item: true, md: 12, className: classes.greyContentPlain, style: { height: previewHeight - 90 - 40 - 40 - (totalWarehouse === 0 ? 0 : 28) } },
                        React.createElement(Grid, { container: true }, (warehouseList ? warehouseList.length : WarehouseModusPage.defaultProps.totalWarehouse) > 0 &&
                            warehouseList.map((data) => (React.createElement(React.Fragment, null,
                                React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentBarWithCloseButton },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { className: classes.contentTitle, item: true, md: 12 }, "Warehouse"),
                                        React.createElement(Grid, { className: classes.blackLeftContent, item: true, md: 12 }, warehouseLayout === 'warehouseName' ? data.warehouseName : data.warehouseCode))),
                                React.createElement(Grid, { item: true, md: 12, className: classes.ContentBorder })))))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Back")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right" }, "Add")))));
};
WarehouseModusPage.defaultProps = {
    scanContentBarText: "Please scan wh/bin...",
    totalWarehouse: 0,
};
export default React.memo(WarehouseModusPage);
